import { RSAA } from 'redux-api-middleware';
import SA from '../actions/sessionActions';

var idler = 0;
export default {
    sessionLogin: (url, credentials, type) => ({ [RSAA]: {
        method: 'POST',
        endpoint: url,
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: JSON.stringify(type == null
            ? credentials
            : type === 'form'
                ? xfsb(credentials)
                : ''
        ),
        types: [
            SA.PENDING_SESSION_LOGIN,
            {
                type: SA.SUCCESS_SESSION_LOGIN,
                payload: (action, state, res) => {
                    log.msg('>>-----> SUCCESS res: ', res);
                    return res.headers.get('Authorization');
                }
            }, {
                type: SA.FAILURE_SESSION_LOGIN,
                payload: (action, state, res) => {
                    log.msg('>>-----> FAILURE res: ', res);
                    return res;
                }
            }
        ]
    }}),
    resetSessionLogin: () => ({ type: SA.RESET_SESSION_LOGIN })
}

function xfsb(o) {
    var s = '';
    for(var p in o) s += p + '=' + o[p] + '&';
    return s.substring(0, s.length - 1);
}
